export default __webpack_public_path__ + "static/media/banner.bc6daab1.png";